import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\AddItemForSalesOptionToEnaosController::__invoke
* @see app/Http/Controllers/Item/AddItemForSalesOptionToEnaosController.php
* @route '/api/item/{item}/enaos/item-for-sales-option'
*/
const AddItemForSalesOptionToEnaosController = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddItemForSalesOptionToEnaosController.url(args, options),
    method: 'post',
})

AddItemForSalesOptionToEnaosController.definition = {
    methods: ["post"],
    url: '/api/item/{item}/enaos/item-for-sales-option',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Item\AddItemForSalesOptionToEnaosController::__invoke
* @see app/Http/Controllers/Item/AddItemForSalesOptionToEnaosController.php
* @route '/api/item/{item}/enaos/item-for-sales-option'
*/
AddItemForSalesOptionToEnaosController.url = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { item: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { item: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
    }

    return AddItemForSalesOptionToEnaosController.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\AddItemForSalesOptionToEnaosController::__invoke
* @see app/Http/Controllers/Item/AddItemForSalesOptionToEnaosController.php
* @route '/api/item/{item}/enaos/item-for-sales-option'
*/
AddItemForSalesOptionToEnaosController.post = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddItemForSalesOptionToEnaosController.url(args, options),
    method: 'post',
})

export default AddItemForSalesOptionToEnaosController